import React from "react";
import { Table } from "react-bootstrap";
import {
    flexRender,
    getCoreRowModel,
    useReactTable
  } from "@tanstack/react-table";
import Skeleton from "react-loading-skeleton";

  interface ISimpleTableProps {
    tableKey: string;
    columns: any;
    data: any;
    isLoading?: boolean;
  }

export default function SimpleTable(props : ISimpleTableProps) {
    const table = useReactTable({
        data: props.data,
        columns: props.columns,
        getCoreRowModel: getCoreRowModel()
      });

    return (
        <React.Fragment>
            <div
                className="table-responsive"
                tabIndex={0}
                aria-label="Scrollable table"
            >
            <Table borderless>
                <thead>
                    {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => (
                                <th
                                    key={header.id}
                                    style={{
                                        width:
                                            header.getSize() !== 150
                                                ? header.getSize() + "%"
                                                : undefined,
                                    }}
                                >
                                    {header.isPlaceholder
                                        ? null
                                        : flexRender(
                                            header.column.columnDef.header,
                                            header.getContext()
                                        )}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {props.isLoading ? (
                        Array.from({ length: 5 }).map((_, rowIndex) => (
                            <tr key={`skeleton-row-${rowIndex}`}>
                                {props.columns.map((_: any, colIndex: number) => (
                                    <td key={`skeleton-cell-${rowIndex}-${colIndex}`}>
                                        <Skeleton height={20} />
                                    </td>
                                ))}
                            </tr>
                        ))
                    ) : (
                        <>
                            {table.getRowModel().rows.map(row => (
                                <tr key={row.id}>
                                    {row.getVisibleCells().map(cell => (
                                        <td key={cell.id}>
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    ))}
                                </tr>
                            ))}

                            {table.getRowModel().rows.length === 0 && (
                                <tr>
                                    <td colSpan={4} className="text-center">
                                        No records found
                                    </td>
                                </tr>
                            )}
                        </>
                    )}
                </tbody>
            </Table>
            </div>
        </React.Fragment>
    )

}